import { useQuery } from "@tanstack/react-query"

import replaceSlugs from "@utils/replaceSlugs"

import { REPORTS_ENDPOINTS } from "@endpoints/reports"

import { ReportDashboard } from "./Reports.types"

const useReportDashboardsQuery = (user: User | null) => {
    const serviceCompanySlug = user?.service_company?.slug ?? "undefined"
    const dashboardsEndpoint = replaceSlugs(REPORTS_ENDPOINTS.DASHBOARDS, {
        service_company_slug: serviceCompanySlug,
    })
    const dashboardsQueryKey = ["report-dashboards", dashboardsEndpoint]

    return useQuery({
        queryKey: dashboardsQueryKey,
        queryFn: async (): Promise<ReportDashboard[]> => {
            const response = await fetch(dashboardsEndpoint)
            if (!response.ok) {
                throw new Error("Failed to fetch report dashboards")
            }
            return (await response.json()) as ReportDashboard[]
        },
        enabled: !!user,
        refetchOnWindowFocus: false,
    })
}

export { useReportDashboardsQuery }
